import React, { useState, useEffect, useRef } from 'react';

const CustomDropdown = ({
    label,
    placeholder = 'Select language',
    options = [],
    value,
    onChange,
    name,
    error,
    required = false,
    className = '',
    disabled = false,
}) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [openDirection, setOpenDirection] = useState('down'); // 'down' | 'up'

    const selectedOption = options.find((opt) => opt.value === value) || null;

    const handleToggle = () => {
        if (!disabled) {
            setOpen((prevOpen) => {
                const nextOpen = !prevOpen;

                if (!prevOpen && dropdownRef.current) {
                    const rect = dropdownRef.current.getBoundingClientRect();
                    const viewportHeight =
                        window.innerHeight || document.documentElement.clientHeight;
                    const spaceBelow = viewportHeight - rect.bottom;

                    // Approximate menu height (item height ~32px + padding), capped at CSS max-height (220px)
                    const estimatedMenuHeight = Math.min(
                        (options?.length || 1) * 32 + 16,
                        220
                    );

                    if (spaceBelow < estimatedMenuHeight + 10) {
                        setOpenDirection('up');
                    } else {
                        setOpenDirection('down');
                    }
                }

                return nextOpen;
            });
        }
    };

    const handleOptionClick = (option) => {
        if (onChange) {
            onChange({
                target: {
                    name,
                    value: option.value,
                },
            });
        }
        setOpen(false);
    };

    // close on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open]);

    return (
        <div className={`form-group ${className}`} ref={dropdownRef}>
            {label && (
                <label>
                    {label} {required && <span className="required">*</span>}
                </label>
            )}
            <div className="custom-dropdown-wrapper">
                <div
                    className={`custom-dropdown ${error ? 'error' : ''} ${open ? 'open' : ''} ${
                        disabled ? 'disabled' : ''
                    }`}
                    onClick={handleToggle}
                >
                    <span className={`custom-dropdown-value ${!selectedOption ? 'placeholder' : ''}`}>
                        {selectedOption ? selectedOption.label : placeholder || 'Select language'}
                    </span>
                    {!disabled && <span className={`custom-dropdown-arrow ${open ? 'open' : ''}`} />}
                </div>
                {open && (
                    <div
                        className={`custom-dropdown-menu ${
                            openDirection === 'up' ? 'open-up' : 'open-down'
                        }`}
                    >
                        {options.length > 0 ? (
                            options.map((option) => (
                                <div
                                    key={option.value}
                                    className={`custom-dropdown-item ${
                                        option.value === value ? 'selected' : ''
                                    }`}
                                    onClick={() => handleOptionClick(option)}
                                >
                                    {option.label}
                                </div>
                            ))
                        ) : (
                            <div className="custom-dropdown-item no-options">No options available</div>
                        )}
                    </div>
                )}
            </div>
            {error && <span className="error-message">{error}</span>}
        </div>
    );
};

export default CustomDropdown;

